export default {
	back_to_top: 'Back to top',
	banner_btn: {
		buy_now: 'Buy now',
		learn_more: 'Learn more',
	},
	banner_list: [
		{
			title: 'Secure · Cost-effective · Global Network Dedicated Servers',
			subtitle: 'Dedicated Physical Server',
			desc: 'Dedicated hardware, customizable high performance, and strong isolation for enterprise-grade workloads across diverse scenarios<br />Empowering stable operations and continuous growth',
		},
		{
			title: 'Lightning-fast NVMe I/O · Next-gen High-performance VPS',
			subtitle: 'NVMe Cloud Server',
			desc: 'Powered by the latest Intel Xeon processors — no need to invest in hardware purchase or maintenance<br />Order, provision, and deploy in minutes',
		},
	],
	data_center: {
		desc: 'Core data centers across Asia, North America, and Europe with direct connections to multiple Tier-1 international carriers and TB-level Chinese 3C dedicated lines, supporting CN2/GIA.',
		list: [
			{ key: 'hk', name: 'Hong Kong' },
			{ key: 'us', name: 'United States' },
			{ key: 'jp', name: 'Japan' },
			{ key: 'kr', name: 'South Korea' },
			{ key: 'my', name: 'Malaysia' },
			{ key: 'sg', name: 'Singapore' },
			{ key: 'au', name: 'Australia' },
		],
		title: 'Data Center Locations',
	},
	product: {
		desc: 'A cost-effective VPS built on next-generation cloud architecture, delivering faster, more stable, and more flexible performance \n Accelerate your projects across the board',
		specialties: [
			{
				title: 'Visual Management Platform',
				desc: 'Smart control center for your cloud servers — power on/off, reset password, reinstall OS, and more, all at your fingertips',
			},
			{
				title: 'Higher Speed',
				desc: 'Pure U.2 NVMe architecture with up to 8000G per disk, IOPS up to 641,800 per disk, throughput up to 3200 MB/s, latency as low as 11µs',
			},
			{
				title: 'Global Multi-network Lines',
				desc: 'Network access to China Telecom, Mobile, Unicom, PCCW, HKBN, NTT, Cogent, Level3, Lumen and more, with custom VPC isolation',
			},
		],
		title: 'Lightning-fast NVMe I/O · Next-gen High-performance VPS',
	},
	products: {
		desc: 'We offer a variety of server products, including VPS hosting and dedicated server rentals, to meet your different needs',
		list: [
			{
				title: 'VPS Hosting',
				desc: 'Fast, stable, and elastic computing service built on NVMe — easily provision and start in the cloud to power your workloads',
			},
			{
				title: 'Dedicated Server',
				desc: 'High-spec hardware ensures stability and performance, with a fully automated platform — one-click reboot, reinstall, and more to power your core business',
			},
		],
		title: 'Multiple Server Products',
	},
	stats: {
		data_centers: 'Data Centers',
		support: 'Support',
		uptime: 'Uptime',
		virtualization: 'Virtualization',
	},
	testimonials: {
		desc: 'We carefully collect feedback and suggestions from every user.',
		title: 'Customer Testimonials',
	},
	testimonials_list: [
		{
			quote: 'Elastic cloud lets you configure resources on demand — no wasted spend, plus the loyalty plan keeps it getting better.',
			name: 'Jerry Liu',
		},
		{
			quote: 'Automatic resource monitoring keeps abusive users in check, ensuring smooth network and responsive disks. Highly recommended.',
			name: 'Will',
		},
		{
			quote: 'Powerful custom panel, online operations at a click, great prices and excellent performance — a solid choice for cloud servers.',
			name: 'Dream',
		},
	],
	why: {
		desc: 'We started in virtual hosting in 2012, expanded to cloud servers in 2014, and launched a new brand in 2019. All our cloud server products use mature KVM virtualization with our in-house Chinese-friendly control panel, delivering mature cloud products with highly-available self-management.',
		list: [
			{
				title: 'Worried about running out of resources?',
				desc: "Your provider says IPs are running out just as your business starts; bandwidth can't keep up with peak traffic; forced migrations cost you dearly",
				solution: 'Solution: Millions of IPs + TB-level bandwidth, IP farm from $80/month',
				case: 'From 1 to 1000 servers — we have you covered',
			},
			{
				title: 'Worried about no support when things break?',
				desc: 'Server goes down at midnight and support asks you to send an English email; technical issues are hard to communicate; nobody to reach when you need help',
				solution: 'Solution: 24/7 native support, 15-minute response for critical issues',
				case: 'Native-language communication, zero friction',
			},
			{
				title: 'Worried about the technical barrier?',
				desc: "Bought a server but don't know how to configure the environment; spending hours just to install WordPress; you want to focus on business, not Linux commands",
				solution: 'Solution: One-click deployment, application live in 3 minutes',
				case: 'Compare: Hours the traditional way → 3–5 minutes with us',
			},
		],
		title: 'Why Choose Us',
	},
}
